import { CUSTOMER_API_URL } from 'configurator-ui-shared';

const {
  VITE_PARTNER_EMBED_URL,
  VITE_EMBED_BASE_URL,
  VITE_PARTNER_DASHBOARD_URL,
  DEV
} = import.meta.env;

// In development, use local partner-embed instance; in production, use deployed URL
const LOCAL_PARTNER_EMBED_URL = 'http://localhost:5175';
const LOCAL_PARTNER_DASHBOARD_URL = 'http://localhost:5176';

export const EMBED_BASE_URL =
  VITE_PARTNER_EMBED_URL ||
  (DEV ? LOCAL_PARTNER_EMBED_URL : VITE_EMBED_BASE_URL) ||
  '';

export const PARTNER_DASHBOARD_URL =
  VITE_PARTNER_DASHBOARD_URL || (DEV ? LOCAL_PARTNER_DASHBOARD_URL : '') || '';

export { CUSTOMER_API_URL };
